import { css } from '@emotion/react'
import { Heading, HFlow, Tag, Text, Theme, useTheme, VFlow } from 'bold-ui'
import { HLabel } from 'components/HLabel'
import { Telefone } from 'components/label'
import { applyMask, masks } from 'util/mask'
import { tipoEnderecoIndigena } from 'view/cadastro-imovel/model-cadastroImovel'
import { getTipoImovelIcon } from 'view/visualizacaoTerritorial/utils/visualizacaoTerritorialUtils'

import { ImovelHeaderDto } from '../model-visualizacao-imovel'
import { MapLink } from './MapLink'

interface VisualizarImovelHeaderContentProps {
  imovel: ImovelHeaderDto
  isProntuarioFamiliar?: boolean
}

export const VisualizarImovelHeaderContent = ({ imovel, isProntuarioFamiliar }: VisualizarImovelHeaderContentProps) => {
  const {
    tipoImovel,
    bairro,
    cep,
    logradouro,
    nomeTipoLogradouro,
    nomeMunicipio,
    siglaUfMunicipio,
    complemento,
    numero,
    telefoneContato,
    telefoneResidencial,
    condicoesMoradia,
    microarea,
    latitude,
    longitude,
    tipoEndereco,
    numeroResidenciaIndigena,
    aldeia,
    poloBase,
    dsei,
  } = imovel

  const theme = useTheme()
  const { divider } = createStyles(theme)

  const isTipoEnderecoIndigena = tipoEnderecoIndigena.includes(tipoEndereco)

  const { HeaderIcon, tooltip } = getTipoImovelIcon(tipoImovel, condicoesMoradia?.tipoDomicilio)

  return (
    <HFlow style={isProntuarioFamiliar && divider}>
      <HeaderIcon
        style={{
          width: '100%',
          height: '100%',
        }}
      />
      <VFlow vSpacing={0.4}>
        <HFlow>
          {isTipoEnderecoIndigena ? (
            <Heading level={1}>
              {aldeia.nome.titleCase()}, {numeroResidenciaIndigena}
            </Heading>
          ) : (
            <Heading level={1}>
              {`${nomeTipoLogradouro ? nomeTipoLogradouro.titleCase() + ' ' : ''}${logradouro?.titleCase()}, ${
                numero ?? 'S/N'
              }`}
            </Heading>
          )}
          <Tag
            type='normal'
            style={css`
              margin-top: 0.4rem;
            `}
          >
            {tooltip}
          </Tag>
        </HFlow>
        {isTipoEnderecoIndigena ? (
          <Text>{`DSEI: ${dsei?.nome?.titleCase()} | Polo base: ${poloBase?.nome?.titleCase()}`}</Text>
        ) : (
          <Text>
            {`${
              complemento ? `${complemento?.titleCase()} - ` : ''
            }${bairro.titleCase()} - ${nomeMunicipio?.titleCase()}/${siglaUfMunicipio?.toUpperCase()}  
                      ${cep ? ' - ' + applyMask(cep, masks.cep) : ''}`}
          </Text>
        )}

        <HFlow>
          <HLabel title='Microárea'>{microarea === 'S/N' ? 'Fora de área' : microarea}</HLabel>
          <HLabel title='Telefone de contato'>
            <Telefone value={telefoneContato} />
          </HLabel>
          <HLabel title='Telefone residencial'>
            <Telefone value={telefoneResidencial} />
          </HLabel>
          <HLabel title='Geolocalização'>
            {latitude && longitude ? <MapLink latitude={latitude} longitude={longitude} /> : undefined}
          </HLabel>
        </HFlow>
      </VFlow>
    </HFlow>
  )
}

const createStyles = (theme: Theme) => ({
  divider: css`
    border: 1px solid ${theme.pallete.divider};
    padding: 1rem;
    margin-bottom: 1rem;
  `,
})
